export default __webpack_public_path__ + "static/media/project6.14bd1701.PNG";